import React from 'react';
import { Invoices } from '../../../components/cartao/cartao-credit-invoices/cartao-credit-invoices';

export default function () {
  return <Invoices />;
}
